import React, { useEffect, useState } from 'react'
import './LoginAccelerator.scss'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import OnboardingHeader from '../Header/AcceleratorHeader/OnboardingHeader'
import { Button } from 'react-bootstrap'
import { GoogleLogin } from '@react-oauth/google'
import { Checkbox, Divider, Input, Button as AntButton, message } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Label } from 'reactstrap'
import { acceleratorGoogleSignin, acceleratorLogin } from '../../redux/auth/authActions'

// Functional component for the Startup login page.
const LoginAccelerator = ({ history, authLoading, acceleratorLogin, acceleratorGoogleSignin }) => {
  const [data, setData] = useState({
    email: '',
    password: '',
    hidden: true,
    error: '',
  })

  const handleChange = e => {
    const { name, value } = e.target
    setData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const acceleratorOnClick = () => {
    acceleratorLogin(
      {
        email: data?.email?.trim(),
        password: data?.password?.trim(),
      },
      res => {
        if (res.result) {
          history.push('/accelerator/onboarding/step-1')
        } else {
          //   message.error(res?.error)
          let parsedStatus
          if (res?.error === 'email exists') {
            parsedStatus = 'That email is already in use. Please log in.'
          } else if (res?.error === 'invalid email') {
            parsedStatus = 'Invalid email'
          } else {
            parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
          }
          setData(prev => ({
            ...prev,
            error: parsedStatus,
          }))
        }
      },
      err => {
        let parsedStatus
        if (err === 'email exists') {
          parsedStatus = 'That email is already in use. Please log in.'
        } else if (err === 'invalid email') {
          parsedStatus = 'Invalid email'
        } else {
          parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
        }
        setData(prev => ({
          ...prev,
          error: parsedStatus,
        }))
      },
    )
  }
  const isSubmitEnabled = () => {
    const validEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/

    const { email, password } = data
    if (validEmail.test(email) && password?.length >= 8) {
      return true
    }
    return false
  }
  const isEnabled = isSubmitEnabled()
  const toggleAlert = () => {
    setData(prev => ({
      ...prev,
      error: '',
    }))
  }

  const acceleratorGoogleOnClick = googleUser => {
    acceleratorGoogleSignin(
      googleUser,
      res => {
        if (res.result) {
          history.push('/accelerator/onboarding/step-1')
        } else {
          //   message.error(res?.error)
          let parsedStatus
          if (res?.error === 'email exists') {
            parsedStatus = 'That email is already in use. Please log in.'
          } else if (res?.error === 'invalid email') {
            parsedStatus = 'Invalid email'
          } else {
            parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
          }
          setData(prev => ({
            ...prev,
            error: parsedStatus,
          }))
        }
      },
      err => {
        let parsedStatus
        if (err === 'email exists') {
          parsedStatus = 'That email is already in use. Please log in.'
        } else if (err === 'invalid email') {
          parsedStatus = 'Invalid email'
        } else {
          parsedStatus = 'An unknown error occurred; please try again and/or contact us.'
        }
        setData(prev => ({
          ...prev,
          error: parsedStatus,
        }))
      },
    )
  }

  const acceleratorGoogleSignupFailure = (errorCode, errorDetails) => {
    // emitStartupSignupFailed(true, errorCode, errorDetails)
    // Do something here
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://exitfund.com/accelerator/login" />
      </Helmet>
      <OnboardingHeader />
      <div className="login-section">
        <h3>accelerator Login</h3>
        <div className="login-with-google">
          <GoogleLogin
            width="300px"
            cookiePolicy={'single_host_origin'}
            onSuccess={googleUser => {
              acceleratorGoogleOnClick(googleUser)
            }}
            onError={({ error, details }) => {
              acceleratorGoogleSignupFailure(error, details)
            }}
          />
        </div>
        <Divider>Or</Divider>
        <form>
          {data.error && (
            <p className={data.error ? 'sign-up-error' : 'close'}>
              {data.error}
              <CloseCircleOutlined onClick={toggleAlert} className="float-right" />
            </p>
          )}
          <div className="form-field">
            <Label>Email Address</Label>
            <Input
              className="text-field-input"
              placeholder="Enter email address"
              name="email"
              type="text"
              onChange={handleChange}
              value={data?.email}
            />
          </div>
          <div className="form-field" style={{ position: 'relative' }}>
            <Label>Password</Label>
            <Input
              className="text-field-input"
              placeholder="Enter password"
              name="password"
              type={data?.hidden ? 'password' : 'text'}
              onChange={handleChange}
              value={data?.password}
            />
            <i
              className={
                data?.hidden
                  ? 'fa fa-eye 3x passing-line-through register-password-icon'
                  : 'fa fa-eye-slash 3x passing-line-through register-password-icon'
              }
              style={{
                bottom: '23%',
                position: 'absolute',
              }}
              onClick={() =>
                setData(prev => ({
                  ...prev,
                  hidden: !data.hidden,
                }))
              }
            />
          </div>
          <div className="rememberme-section">
            <Checkbox>Remember me</Checkbox>
            <Link
              to={'/accelerator/forgot-password'}
              style={{
                color: '#1D6AC5',
                fontSize: '15px',
              }}
              className="forgot-password"
            >
              Forgot Password?
            </Link>
          </div>
          <AntButton
            loading={authLoading}
            disabled={!isEnabled}
            onClick={acceleratorOnClick}
            className="sign-in"
          >
            Login
          </AntButton>
        </form>
        <p className="dont-have-acc">
          <Link to="/accelerator/signup">Don't have an account? Sign up</Link>
        </p>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  authLoading: state?.auth?.loading,
})

const mapDispatchToProps = dispatch => ({
  acceleratorLogin: (data, onSuccess, onFail) => dispatch(acceleratorLogin(data, onSuccess, onFail)),
  acceleratorGoogleSignin: (data, onSuccess, onFail) =>
    dispatch(acceleratorGoogleSignin(data, onSuccess, onFail)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginAccelerator)
